import React, { useState } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Rating } from "primereact/rating";
import { useDispatch } from "react-redux";
import { addReview } from "../../store/AsyncMethods/ReviewsMethod";

export default function AddReview() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    customer_name: "",
    product_name: "",
    rating: 0,
    comment: "",
    status: "pending",
  });

  const [loading, setLoading] = useState(false);

  const statusOptions = [
    { label: "Pending", value: "pending" },
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
  ];

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate form data
      if (!formData.customer_name || !formData.product_name || !formData.comment) {
        toast.error("Please fill in all required fields");
        return;
      }

      if (formData.rating === 0) {
        toast.error("Please select a rating");
        return;
      }

      const success = await dispatch(addReview(formData));
      if (success) {
        toast.success("Review added successfully!");
        navigate("/manage-reviews");
      }
    } catch (error) {
      toast.error("Error adding review. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/manage-reviews");
  };

  return (
    <div className="p-4 bg-gray-50 min-h-screen">
      <div className="flex justify-between items-center mb-4">
        <div>
          <p className="text-sm text-gray-500">Home &gt; Manage Reviews &gt; Add Review</p>
        </div>
      </div>

      <Card className="max-w-2xl mx-auto">
        <div className="mb-4">
          <h2 className="text-2xl font-bold text-gray-800">Add New Review</h2>
          <p className="text-gray-600">Create a new review for a product</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="customer_name" className="block text-sm font-medium text-gray-700 mb-2">
                Customer Name *
              </label>
              <InputText
                id="customer_name"
                value={formData.customer_name}
                onChange={(e) => handleInputChange("customer_name", e.target.value)}
                className="w-full"
                placeholder="Enter customer name"
              />
            </div>

            <div>
              <label htmlFor="product_name" className="block text-sm font-medium text-gray-700 mb-2">
                Product *
              </label>
              <InputText
                id="product_name"
                value={formData.product_name}
                onChange={(e) => handleInputChange("product_name", e.target.value)}
                className="w-full"
                placeholder="Enter product name"
              />
            </div>
          </div>

          <div>
            <label htmlFor="rating" className="block text-sm font-medium text-gray-700 mb-2">
              Rating *
            </label>
            <Rating
              value={formData.rating}
              onChange={(e) => handleInputChange("rating", e.value)}
              stars={5}
              cancel={false}
            />
            <span className="ml-2 text-sm text-gray-600">
              {formData.rating > 0 ? `(${formData.rating}/5 stars)` : ""}
            </span>
          </div>

          <div>
            <label htmlFor="comment" className="block text-sm font-medium text-gray-700 mb-2">
              Review Comment *
            </label>
            <InputTextarea
              id="comment"
              value={formData.comment}
              onChange={(e) => handleInputChange("comment", e.target.value)}
              rows={4}
              className="w-full"
              placeholder="Enter review comment..."
              autoResize
            />
          </div>

          <div>
            <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-2">
              Status
            </label>
            <Dropdown
              id="status"
              value={formData.status}
              options={statusOptions}
              onChange={(e) => handleInputChange("status", e.value)}
              className="w-full"
              placeholder="Select status"
            />
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="submit"
              label="Add Review"
              icon="pi pi-plus"
              className="p-primary-btn"
              loading={loading}
            />
            <Button
              type="button"
              label="Cancel"
              icon="pi pi-times"
              className="p-button-secondary"
              onClick={handleCancel}
            />
          </div>
        </form>
      </Card>
    </div>
  );
} 